function assert(check, message, opt_objectToLog) {
  if (!check) {
    console.log('Assertion failure object:');
    console.dir(opt_objectToLog);
    throw new Error(message);
  }
}

export default assert;
